import { InjectionToken } from "@angular/core";
import { AdobeAnalyticsService } from "../services/adobe-analytics.service";

export const ADOBE_ANALYTICS_CONFIG = new InjectionToken<AdobeAnalyticsService>("ADOBE_ANALYTICS_CONFIG");

declare global {
    interface Window {
        digitalData: any;
        _satellite: any;
    }
}
